import { TimesheetStatusEnum } from 'api/backofficeApiClient';
import { EventValue } from 'rc-picker/lib/interface';
import { Moment } from 'moment';

export interface DateParams {
  startDate?: EventValue<Moment>;
  endDate?: EventValue<Moment>;
}

const getSelectedFilterValues = <T>(types: T[], allValue: T): T[] => {
  if (types.includes(allValue)) {
    const allIndex = types.findIndex((element) => {
      return element === allValue;
    });

    if (allIndex === types.length - 1) {
      return [allValue];
    }
    types.splice(allIndex, 1);
  }
  return types;
};

const getStateFilterOptionLabel = (state?: TimesheetStatusEnum) => {
  switch (state) {
    case TimesheetStatusEnum.Submitted:
      return 'Submitted';

    case TimesheetStatusEnum.Open:
      return 'Open';

    case TimesheetStatusEnum.Approved:
      return 'Approved';

    case TimesheetStatusEnum.All:
      return 'All';

    default:
      return '';
  }
};

export { getSelectedFilterValues, getStateFilterOptionLabel };
